import React from "react";
import { Instagram, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-black border-t border-zinc-900 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-10 h-10 bg-red-500 flex items-center justify-center font-display text-black text-xl">
                R
              </span>
              <span className="font-display text-2xl tracking-tight">
                ROYSTON<span className="text-red-500">.</span>
              </span>
            </div>
            <p className="text-zinc-400 max-w-md leading-relaxed">
              Obsessive mobile auto detailing in Sheboygan, Wisconsin. Ceramic
              coatings, paint correction, and interior restoration for those
              who notice the difference.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 mb-6">
              Navigate
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#services" className="text-zinc-300 hover:text-red-500 transition-colors">Services</a></li>
              <li><a href="#packages" className="text-zinc-300 hover:text-red-500 transition-colors">Packages</a></li>
              <li><a href="#gallery" className="text-zinc-300 hover:text-red-500 transition-colors">Gallery</a></li>
              <li><a href="#about" className="text-zinc-300 hover:text-red-500 transition-colors">About</a></li>
              <li><a href="#faq" className="text-zinc-300 hover:text-red-500 transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs tracking-[0.3em] uppercase text-zinc-500 mb-6">
              Studio
            </div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li>812 N 8th St</li>
              <li>Sheboygan, WI 53081</li>
              <li className="pt-2">
                <a href="tel:+19206278405" className="hover:text-red-500 transition-colors">
                  920 627 8405
                </a>
              </li>
              <li>
                <a href="mailto:roystonmobiledetailing@gmail.com" className="hover:text-red-500 transition-colors">
                  roystonmobiledetailing@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-zinc-900">
          <div className="font-display text-6xl sm:text-8xl lg:text-[10rem] uppercase tracking-tighter leading-none text-zinc-900 select-none">
            APEX DETAILING.
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-xs tracking-[0.2em] uppercase text-zinc-600">
            © {new Date().getFullYear()} Royston Mobile Detailing · All rights reserved
          </div>
          <div className="flex items-center gap-4">
            <a
              href="#"
              aria-label="Instagram"
              className="w-10 h-10 border border-zinc-800 hover:border-red-500 flex items-center justify-center text-zinc-400 hover:text-red-500 transition-all"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="w-10 h-10 border border-zinc-800 hover:border-red-500 flex items-center justify-center text-zinc-400 hover:text-red-500 transition-all"
            >
              <Facebook size={16} />
            </a>
            <a
              href="#"
              aria-label="YouTube"
              className="w-10 h-10 border border-zinc-800 hover:border-red-500 flex items-center justify-center text-zinc-400 hover:text-red-500 transition-all"
            >
              <Youtube size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
